import { useAddons } from '@/react/portainer/addons/queries/useAddons';
import { useSystemInfo } from '@/react/portainer/system/useSystemInfo';
import { useFIPSMode } from '@/react/portainer/settings/queries/useFIPSMode';

import { PageHeader } from '@@/PageHeader';
import { Loading } from '@@/Widget';
import { Alert } from '@@/Alert';

import { AddonsCards } from './AddonsCards';

export function ListView() {
  const isFIPSMode = useFIPSMode();
  // Addons are excluded entirely in FIPS mode: the API is not mounted, so the
  // catalog is not requested and only the exclusion message is shown.
  const addonsListQuery = useAddons({ enabled: !isFIPSMode });
  const addonsList = addonsListQuery.data;
  const { data: systemInfo } = useSystemInfo();
  const addonsAvailable = systemInfo?.addonsAvailable ?? false;

  return (
    <>
      <PageHeader
        title="Add-ons"
        breadcrumbs={[{ label: 'Add-on management' }]}
        reload
      />

      <div className="row">
        <p className="col-sm-12 mb-0 text-sm text-[var(--text-muted-color)]">
          Discover tools that integrate seamlessly with your workflow and boost
          productivity.
        </p>
      </div>

      {isFIPSMode ? (
        <div className="row mt-4">
          <div className="col-sm-12">
            <Alert color="warn" title="Add-ons are not available in FIPS mode">
              Add-ons cannot be installed or managed while Portainer is running
              in FIPS mode.
            </Alert>
          </div>
        </div>
      ) : (
        <>
          {!addonsAvailable && (
            <div className="row mt-4">
              <div className="col-sm-12">
                <Alert
                  color="warn"
                  title="Add-ons require a Kubernetes environment"
                >
                  Portainer must be running on a local Kubernetes environment
                  and connected.
                </Alert>
              </div>
            </div>
          )}

          {!addonsList ? (
            <Loading />
          ) : (
            <AddonsCards catalog={addonsList} disabled={!addonsAvailable} />
          )}
        </>
      )}
    </>
  );
}
